import { SVGProps } from 'react';

const FlagCircleUk = ({
  width = '32',
  height = '32',
  ...otherProps
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 32 32'
    {...otherProps}
  >
    <g clipPath='url(#clip0_518_6381)'>
      <path
        fill='#F0F0F0'
        d='M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z'
      ></path>
      <path
        fill='#0052B4'
        d='M3.308 6.259A15.942 15.942 0 00.55 11.826h8.324L3.308 6.26zM31.449 11.826a15.944 15.944 0 00-2.756-5.567l-5.568 5.567h8.324zM.551 20.174a15.943 15.943 0 002.757 5.567l5.567-5.567H.55zM25.741 3.307A15.942 15.942 0 0020.174.551v8.323l5.567-5.567zM6.259 28.692a15.944 15.944 0 005.567 2.756v-8.323l-5.567 5.567zM11.826.55a15.943 15.943 0 00-5.567 2.757l5.567 5.567V.551zM20.174 31.448a15.944 15.944 0 005.567-2.756l-5.567-5.567v8.323zM23.125 20.174l5.568 5.567a15.943 15.943 0 002.756-5.567h-8.324z'
      ></path>
      <path
        fill='#D80027'
        d='M31.865 13.913H18.087V.135a16.16 16.16 0 00-4.174 0v13.778H.135a16.16 16.16 0 000 4.174h13.778v13.778a16.166 16.166 0 004.174 0V18.087h13.778a16.166 16.166 0 000-4.174z'
      ></path>
      <path
        fill='#D80027'
        d='M20.174 20.174l7.14 7.14c.328-.329.641-.672.94-1.027l-6.113-6.113h-1.967zM11.826 20.174l-7.14 7.14c.328.328.671.641 1.027.94l6.113-6.113v-1.967zM11.826 11.826l-7.14-7.14c-.328.329-.642.672-.94 1.028l6.112 6.112h1.968zM20.174 11.826l7.14-7.14a16.023 16.023 0 00-1.027-.94L20.174 9.86v1.967z'
      ></path>
    </g>
    <defs>
      <clipPath id='clip0_518_6381'>
        <path fill='#fff' d='M0 0H32V32H0z'></path>
      </clipPath>
    </defs>
  </svg>
);

export default FlagCircleUk;
